import { GET_USER_FILTERS, GET_FILTER_DETAILS } from '../../types'

const initialState = {
  filters: [],
  targetFilter: {
    filterID: '',
    filterName: '',
    startTime: 0,
    endTime: 0,
    startDate: 0,
    endDate: 0,
    captureSource: 0,
    workstations: [],
    users: [],
    categories: [],
    statuses: [],
    isFastFilter: 0
  }
}

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_FILTERS: return {
      ...state,
      filters: action.payload
    }
    case GET_FILTER_DETAILS: {
      const {
        filterID, filterName, startTime, startDate, endTime, endDate,
        captureSource, severityMin, severityMax,
        workstations, users, categories, statuses, isFastFilter
      } = action.payload

      return {
        ...state,
        targetFilter: {
          filterID,
          filterName,
          startTime,
          startDate,
          endTime,
          endDate,
          captureSource,
          severityMin,
          severityMax,
          workstations,
          users,
          categories,
          statuses,
          isFastFilter
        }
      }
    }
    default: return { ...state }
  }
}

export default filterReducer
